// Cambridge A2 Flyers vocab.js — Week 36
export default {
  vocab: [
  {
    "word": "mysterious",
    "definition_en": "difficult or impossible to understand or explain",
    "definition_vi": "bí ẩn",
    "example": "They found a mysterious entrance behind the rock.",
    "ipa": "/mɪˈstɪə.ri.əs/",
    "image_url": "/images/week36/vocab_1.jpg"
  },
  {
    "word": "flashlight",
    "definition_en": "a portable battery-powered electric lamp",
    "definition_vi": "đèn pin",
    "example": "Turn on your flashlight inside the dark cave.",
    "ipa": "/ˈflæʃ.laɪt/",
    "image_url": "/images/week36/vocab_2.jpg"
  },
  {
    "word": "entrance",
    "definition_en": "an opening that allows access to a place",
    "definition_vi": "lối vào",
    "example": "The cave entrance was covered with vines.",
    "ipa": "/ˈen.trəns/",
    "image_url": "/images/week36/vocab_3.jpg"
  },
  {
    "word": "ancient",
    "definition_en": "belonging to the very distant past",
    "definition_vi": "cổ xưa",
    "example": "The explorer drew an ancient parchment map.",
    "ipa": "/ˈeɪn.ʃənt/",
    "image_url": "/images/week36/vocab_4.jpg"
  },
  {
    "word": "compass",
    "definition_en": "an instrument showing magnetic north used for navigation",
    "definition_vi": "la bàn",
    "example": "Use a shiny brass compass to find north.",
    "ipa": "/ˈkʌm.pəs/",
    "image_url": "/images/week36/vocab_5.jpg"
  },
  {
    "word": "stalactite",
    "definition_en": "an icicle-shaped formation hanging from a cave ceiling",
    "definition_vi": "nhũ đá",
    "example": "Water dripped from a long stalactite.",
    "ipa": "/ˈstæl.ək.taɪt/",
    "image_url": "/images/week36/vocab_6.jpg"
  },
  {
    "word": "explorer",
    "definition_en": "a person who explores an unfamiliar area",
    "definition_vi": "nhà khám phá",
    "example": "Brave explorers mapped the deep cave.",
    "ipa": "/ɪkˈsplɔː.rər/",
    "image_url": "/images/week36/vocab_7.jpg"
  },
  {
    "word": "parchment",
    "definition_en": "a stiff flat material made from animal skin for writing",
    "definition_vi": "cuộn giấy da",
    "example": "The ancient map was written on parchment.",
    "ipa": "/ˈpɑːtʃ.mənt/",
    "image_url": "/images/week36/vocab_8.jpg"
  },
  {
    "word": "shadow",
    "definition_en": "a dark area produced by a body coming between rays of light",
    "definition_vi": "bóng râm",
    "example": "Dark grey shadows danced on the rocky wall.",
    "ipa": "/ˈʃæd.əʊ/",
    "image_url": "/images/week36/vocab_9.jpg"
  },
  {
    "word": "underground",
    "definition_en": "situated beneath the surface of the earth",
    "definition_vi": "dưới lòng đất",
    "example": "The underground lake was icy cold.",
    "ipa": "/ˌʌn.dəˈɡraʊnd/",
    "image_url": "/images/week36/vocab_10.jpg"
  },
  {
    "word": "chamber",
    "definition_en": "a large room or enclosed space in a cave",
    "definition_vi": "ngăn hang động",
    "example": "They stepped into a wide stone chamber.",
    "ipa": "/ˈtʃeɪm.bər/",
    "image_url": "/images/week36/vocab_11.jpg"
  },
  {
    "word": "adventure",
    "definition_en": "an unusual and exciting experience",
    "definition_vi": "cuộc phiêu lưu",
    "example": "Hiking in the forest was a great adventure.",
    "ipa": "/ədˈven.tʃər/",
    "image_url": "/images/week36/vocab_12.jpg"
  },
  {
    "word": "discover",
    "definition_en": "find unexpectedly or during a search",
    "definition_vi": "khám phá",
    "example": "They discovered a wooden treasure box.",
    "ipa": "/dɪˈskʌv.ər/",
    "image_url": "/images/week36/vocab_13.jpg"
  },
  {
    "word": "ceiling",
    "definition_en": "the upper interior surface of a room or cave",
    "definition_vi": "trần hang",
    "example": "Water dripped from the rocky ceiling.",
    "ipa": "/ˈsiː.lɪŋ/",
    "image_url": "/images/week36/vocab_14.jpg"
  },
  {
    "word": "drip",
    "definition_en": "fall in small drops of liquid",
    "definition_vi": "nhỏ giọt",
    "example": "Cool water drops drip silently.",
    "ipa": "/drɪp/",
    "image_url": "/images/week36/vocab_15.jpg"
  },
  {
    "word": "treasure",
    "definition_en": "a quantity of precious metals, gems, or valuable items",
    "definition_vi": "kho báu",
    "example": "The map led to a historical treasure.",
    "ipa": "/ˈtreʒ.ər/",
    "image_url": "/images/week36/vocab_16.jpg"
  },
  {
    "word": "historical",
    "definition_en": "concerning history or past events",
    "definition_vi": "thuộc lịch sử",
    "example": "They found a historical map from 1850.",
    "ipa": "/hɪˈstɒr.ɪ.kəl/",
    "image_url": "/images/week36/vocab_17.jpg"
  },
  {
    "word": "hiking",
    "definition_en": "the activity of going for long walks in the countryside",
    "definition_vi": "đi bộ đường dài",
    "example": "We enjoy hiking in the pine forest.",
    "ipa": "/ˈhaɪ.kɪŋ/",
    "image_url": "/images/week36/vocab_18.jpg"
  },
  {
    "word": "forest",
    "definition_en": "a large area covered chiefly with trees and undergrowth",
    "definition_vi": "rừng cây",
    "example": "Tall trees grew in the pine forest.",
    "ipa": "/ˈfɒr.ɪst/",
    "image_url": "/images/week36/vocab_19.jpg"
  },
  {
    "word": "courage",
    "definition_en": "the ability to do something that frightens one",
    "definition_vi": "lòng dũng cảm",
    "example": "Exploring dark caves requires true courage.",
    "ipa": "/ˈkʌr.ɪdʒ/",
    "image_url": "/images/week36/vocab_20.jpg"
  }
]
};
